import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppAppBar from './components/marketing-page/components/AppAppBar';
import SignInPage from './pages/Auth/SignIn/SignInPage';
import SignUpPage from './pages/Auth/SignUp/SignUpPage';
import AppTheme from './components/shared-theme/AppTheme';
import { CssBaseline, Divider } from '@mui/material';
import Hero from './components/marketing-page/components/Hero';
import Footer from './components/marketing-page/components/Footer';
import { createStore, applyMiddleware } from "redux";
import appReducer from "./configuration/redux/reducers";
import { thunk } from "redux-thunk";
import { Provider } from 'react-redux';
import UserProfile from './pages/UserProfile/UserProfile';
import SelectUserCategories from './pages/Categories/SelectUserCategories/SelectUserCategories';
import OnboardingProvider from './components/HoC/OnboardingProvider';
import AuthProvider from './components/HoC/AuthProvider';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import LogVisitsProvider from './components/HoC/LogVisitsProvider';
import BrowseHandymanPage from './pages/BrowseHandyman/BrowseHandymanPage';
import HandymanDetails from './pages/BrowseHandyman/HandymanDetails/HandymanDetails';
import OrdersPage from './pages/Orders/OrdersPage';
import CreateOrderPage from './pages/Orders/CreateOrderPage';
import OrderDetailsPage from './pages/Orders/OrderDetailsPage';
import ChatsPage from './pages/Chats/ChatsPage';
import OrderReviewsPage from './pages/Reviews/OrderReviewsPage';
import UserReviewsPage from './pages/Reviews/UserReviewsPage';
import OrderProposalsPage from './pages/Proposals/OrderProposalsPage';
import GoogleMapsWrapper from './pages/UserProfile/components/UserDetails/GoogleMapsWrapper';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import SupportPage from './pages/Support/SupportPage';

const middlewares = [thunk as any];
export const store = createStore(appReducer, applyMiddleware(...middlewares));
export type AppDispatch = typeof store.dispatch;
const stripePromise = loadStripe("pk_test_51RFYVUR24K34pOhwZhAolIzyRdqQjlGMNuTf2j9pwpIAWpGekg2v33wyciHggDd0ldTnxgbUU4yfHqEesn9yH3FM00zQC8cgtS");

const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <AppTheme>
          <BrowserRouter>
            <LogVisitsProvider />
            <OnboardingProvider>
              <CssBaseline enableColorScheme />
              <AppAppBar />

              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Hero />} />
                <Route path="sign-in" element={<SignInPage />} />
                <Route path="sign-up" element={<SignUpPage />} />
                <Route path="support" element={<SupportPage />} />

                {/* Protected Routes */}
                <Route
                  path="profile"
                  element={
                    <ProtectedRoute>
                      <UserProfile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="select-categories"
                  element={
                    <ProtectedRoute>
                      <SelectUserCategories />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="browse-handyman"
                  element={
                    <BrowseHandymanPage />
                  }
                />
                <Route
                  path="browse-handyman/:userId"
                  element={
                    <HandymanDetails />
                  }
                />
                <Route
                  path="orders"
                  element={
                    <ProtectedRoute>
                      <GoogleMapsWrapper>
                        <OrdersPage />
                      </GoogleMapsWrapper>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="orders/:orderId"
                  element={
                    <ProtectedRoute>
                      <Elements stripe={stripePromise}>
                      <OrderDetailsPage />
                    </Elements>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="create-order"
                  element={
                    <ProtectedRoute>
                      <GoogleMapsWrapper>
                        <CreateOrderPage />
                      </GoogleMapsWrapper>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="chats"
                  element={
                    <ProtectedRoute>
                      <ChatsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="chats/:chatId"
                  element={
                    <ProtectedRoute>
                      <ChatsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="reviews/order/:orderId"
                  element={
                    <ProtectedRoute>
                      <OrderReviewsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="reviews/user/:userId"
                  element={
                    <ProtectedRoute>
                      <UserReviewsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="proposals/order/:orderId"
                  element={
                    <ProtectedRoute children={<OrderProposalsPage />} />
                  }
                />
              </Routes>
                <Divider />
                <Footer />
            </OnboardingProvider>
          </BrowserRouter>
        </AppTheme>
      </AuthProvider>
    </Provider>
  );
}

export default App;
